import createEngine, {
  DiagramModel,
  RightAngleLinkFactory,
} from "@projectstorm/react-diagrams";
import * as React from "react";
import { useDispatch } from "react-redux";
import ProjectBuilderMainWindow from "./ProjectBuilderMainWindow";
import ComponentNodeFactory from "./nodes/ComponentNodeFactory";
import { setCurrentModal } from "../store/slices/modalsSlice";
import ComponentLinkFactory from "./nodes/ComponentLinkFactory";
import ComponentLinkLabelFactory from "./nodes/ComponentLinkLabelFactory";
import ComponentPortFactory from "./nodes/ComponentPortFactory";

export default function ProjectBuilder() {
  // 1) setup the diagram engine
  const engine = createEngine({
    registerDefaultDeleteItemsAction: false,
    registerDefaultZoomCanvasAction: false,
  });
  // disable dangling links
  engine
    .getStateMachine()
    .getCurrentState().dragNewLink.config.allowLooseLinks = false;

  engine.getNodeFactories().registerFactory(new ComponentNodeFactory());
  engine.getLinkFactories().registerFactory(new ComponentLinkFactory());
  engine.getLinkFactories().registerFactory(new RightAngleLinkFactory());
  engine.getLabelFactories().registerFactory(new ComponentLinkLabelFactory());
  engine.getPortFactories().registerFactory(new ComponentPortFactory());

  const dispatch = useDispatch();

  // 2) setup the diagram model
  const model = new DiagramModel();
  model.registerListener({
    linksUpdated: (event) => {
      event.link.registerListener({
        targetPortChanged: (e) => {
          const targetID = e.entity.targetPort.parent.options.component.ID;
          const sourceID = e.entity.sourcePort.parent.options.component.ID;
          dispatch(
            setCurrentModal({
              modal: "activation",
              data: { targetID, sourceID },
            })
          );
        },
      });
    },
  });
  model.setGridSize(150);
  // 5) load model into engine
  engine.setModel(model);

  // 6) render the diagram!

  return <ProjectBuilderMainWindow engine={engine} />;
}
